import { autoMount } from '../engine/mount';
import { ensureStylesheet } from '../engine/lib/stylesheet';
import { hsaSavingsConfig, hsaSavingsOdonlowConfig, hsaSavingsSpotlightConfig } from '../calculators/hsa-savings/config';
import '../engine/styles/index.scss';
import '../calculators/hsa-savings/styles.scss';

// Layout is chosen per placement (hsaSavingsCalc.yaml → options.layout).
// Anything but a known layout (including absent, on cached pages) is legacy.
// Each layout's look is its own stylesheet (calc-hsa-savings-<layout>.css,
// built by scripts/build-layout-css.mjs), normally linked by the FTL.
const LAYOUTS = {
  legacy: hsaSavingsConfig,
  spotlight: hsaSavingsSpotlightConfig,
  odonlow: hsaSavingsOdonlowConfig,
};

autoMount('hsa-savings', (options) => {
  const layout = options.layout === 'spotlight' || options.layout === 'odonlow' ? options.layout : 'legacy';
  ensureStylesheet(`hsa-savings-${layout}`, options.assetBase, import.meta.url);
  return LAYOUTS[layout];
});
